module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/07-1a9d00323a0d3c661cace0c96050f9fe.png";